import { useSearchParams } from "react-router-dom";
import { useContentShowQuery } from "@/admin/entities/contents";
import {
  getColumnsConfig,
  getMobileColumnsConfig,
  getTextsConfig,
} from "./config";
import { getTableData, mapColumns } from "./mappers";

export function useStreamsManagement() {
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");

  useContentShowQuery(id, id === null);

  return {
    columns: getColumnsConfig(),
    mobileColumns: getMobileColumnsConfig(),
    mapColumns,
    getTableData,
    texts: getTextsConfig(),
  };
}
